var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',[_c('img',{attrs:{"src":"/assets/icon/icon-delete.svg"}}),_vm._v(" "+_vm._s(_vm.$t('Warenkorb leeren'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }